import { BackupAction } from './plan-backup-actions-model';

export class BackupActionPost extends BackupAction {
  public RunOnBackupFailure: boolean;
  constructor() {
    super();
  }
}
